/** Deterministički PRNG (mulberry32) — isti seed daje uvek istu mapu. */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0
  return () => {
    a = (a + 0x6d2b79f5) >>> 0
    let t = Math.imul(a ^ (a >>> 15), 1 | a)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}

/** Seed iz proizvoljnog stringa, da igrači mogu da razmenjuju mape po imenu. */
export function hashSeed(text: string): number {
  let h = 2166136261 >>> 0
  for (let i = 0; i < text.length; i++) {
    h ^= text.charCodeAt(i)
    h = Math.imul(h, 16777619)
  }
  return h >>> 0
}

/** Kratak čitljiv seed za prikaz u UI. */
export function randomSeedWord(): string {
  const slogovi = ['ka', 'lo', 'ri', 'men', 'tar', 'sol', 'vi', 'du', 'ner', 'gal', 'ba', 'tro']
  const r = mulberry32((Math.random() * 4294967296) >>> 0)
  let s = ''
  for (let i = 0; i < 3; i++) s += slogovi[Math.floor(r() * slogovi.length)]
  return s
}
